import { Point } from '@/classes/Point';

export class ShootingPinPoint extends Point {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  dotted: boolean;

  constructor(readonly params: any) {
    super(params);
  }
}
